var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71035 5.76786C8.61739 5.85932 8.50679 5.93192 8.38494 5.98146C8.26309 6.03101 8.13239 6.05651 8.00039 6.05651C7.86838 6.05651 7.73769 6.03101 7.61583 5.98146C7.49398 5.93192 7.38339 5.85932 7.29043 5.76786L2.71069 1.28866C2.61774 1.19719 2.50714 1.12459 2.38529 1.07505C2.26344 1.02551 2.13274 1 2.00073 1C1.86873 1 1.73803 1.02551 1.61618 1.07505C1.49433 1.12459 1.38373 1.19719 1.29078 1.28866C1.10454 1.4715 1 1.71883 1 1.97664C1 2.23445 1.10454 2.48178 1.29078 2.66462L5.88051 7.14382C6.44298 7.69206 7.20543 8 8.00039 8C8.79534 8 9.5578 7.69206 10.1203 7.14382L14.71 2.66462C14.8947 2.48286 14.9989 2.23753 15 1.98152C15.0007 1.85309 14.9755 1.72578 14.9258 1.60688C14.876 1.48798 14.8027 1.37984 14.71 1.28866C14.617 1.19719 14.5064 1.12459 14.3846 1.07505C14.2627 1.02551 14.132 1 14 1C13.868 1 13.7373 1.02551 13.6155 1.07505C13.4936 1.12459 13.383 1.19719 13.2901 1.28866L8.71035 5.76786Z",
    fill: "#D9D9D9",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e0b3f171b0c146e99457fab8ca7a1f3c.svg";
export { ForwardRef as ReactComponent };